import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, withMsal, useMsal } from "@azure/msal-react";
import { loginRequest } from "./config/msal/authConfig";
import App from "./containers/App";
import ErrorPage from './containers/Common/ErrorPage';
import "../styles/style.scss";

import { store } from "./index";
// load open sans from google fonts and local font-awesome
// import './config/fontLoader';

const Application: any = ({ token }) => {
    const { instance, accounts, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [accessToken, setAccessToken] = useState(null);

    // function login() {
    //     instance.loginRedirect(loginRequest).catch(e => {
    //         console.log(e);
    //     })
    // }
    const checkAuthenticationState = () => {
        // instance.ssoSilent({
        //     scopes: ["openid"],
        //     sid: ' ',
        //     redirectUri: '/',
        // }).then((response) => {
        //     // user is authenticated
        //     console.log(response);
        // }).catch((error) => {
        //     // user is not authenticated
        //     console.log(error);
        // });
    };
    useEffect(() => {
        checkAuthenticationState();
    }, []);

    useEffect(() => {
        if (accounts.length > 0 && token === null) {
            const request = {
                scopes: loginRequest.scopes,
                account: accounts[0]
            };
            instance.acquireTokenSilent(request).then(response => {
                setAccessToken(response.idToken);
                store.dispatch({ type: 'ADD_TOKEN', token: response.idToken })

                localStorage.setItem('adal.tok', response.idToken);
                localStorage.setItem('adal.adm', JSON.stringify(accounts[0]));
                // console.log(JSON.stringify(accounts[0]));
            }).catch(error => {
                // acquireTokenSilent can fail for a number of reasons, fallback to interaction
                if (error) {
                    instance.acquireTokenPopup(request).then(response => {
                        setAccessToken(response.idToken);
                        store.dispatch({ type: 'ADD_TOKEN', token: response.idToken })
                    });
                }
            });
        }
        return () => {
            setAccessToken(null);
        }
    }, [accounts])

    return (
        <>
            {token ? <AuthenticatedTemplate>
                <Router>
                    {accessToken ? <App /> : null}
                </Router>
            </AuthenticatedTemplate> : null}
            <UnauthenticatedTemplate>
                {inProgress === "none" ? <ErrorPage flag={true} /> : null}
            </UnauthenticatedTemplate>
        </>
    );
}

const mapStateToProps = ({ stateToken }) => ({
    token: stateToken,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withMsal(Application));
